import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import AllCatalogMgr from './components/AllCatalogMgr';
import CardPanel from '../../../../shared/components/widgets/CardPanel';

export default function CatalogIndexPage() {
  const sellerSelect = useSelector(state => state.sellerSelect);
  const sellerConfig = {
    title: 'SKU Catalog Manager',
    endpoint: 'sellers/sku-catalog',
    uploadPath: 'upload-sku-master',
  }
  const vendorConfig = {
    title: 'ASIN Catalog Manager',
    endpoint: 'vendors/asin-catalog',
    uploadPath: 'upload-asin-master',
  }

  const accountConfig = (sellerSelect.type === 1) ? sellerConfig : vendorConfig;

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">{accountConfig.title}</h3>
        </Col>
        <Col md={12}>
          <CardPanel
            showButtons={false}
          >
            <p>
              Catalog UPLOAD now allows for PARTIAL updates, you only need to include rows with changes in the file.<br />
              To delete from Limitless Master data, put the word &quot;DELETE&quot; in *SKU for Vendor* OR *ASIN for SELLER* field.  NOTE: Do not change primriry fields Vendor=ASIN, Seller=SKU<br />
              Status Flags are change flags, not guarenteed to be the current state for all ADs with that ASIN/SKU.<br />
              SP and SD Status can be manged indepently if AD Status is ON. AD Status of OFF is OFF for SP and SD by default.<br />
              On upload, the system will look for changes in the Status and compare the reqeust to the currently daily AD data to determie if a action is needed.  If a change is found, it will queue up the change accordling.  This means you can only do one ASIN/SKU update a day.
            </p>
          </CardPanel>
        </Col>
      </Row>
      <Row>
        <AllCatalogMgr accountConfig={accountConfig} />
      </Row>
    </Container>
  );
}
